import React from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';

/*
    * vidx 13 ---> grupa 2
    * vidx 15 ---> grupa 3

    * REDMINE 10122

    * W opisie nie pokazujemy grupy 4 tylko doklejamy piktogramy do grupy 2. Dodatkowo zmieniamy tytuł grupy 2 łącząc go z grupą 3.
   
    * groupTwoAndFourTitleArray został stworzony po to, żeby łatwiej stworzyć tytuł dla grupy składającej się z dwóch grup.
    
    * !item.types.hasOwnProperty('15') ---> nie pokazujemy nic z grupy 3
*/

const ColorsGroupPopup = ({ colorLists, colorGroups }) => {
  const groupTwoAndFourTitleArray = Object.keys(colorGroups).reduce((acc, vidx) => {
    const value = colorGroups[vidx];

    if (String(vidx) === '13' || String(vidx) === '15') {
      const splittedValue = value.split(' - ');
      acc.push(splittedValue[0]);
      acc.push(splittedValue[1]);
    }

    return acc;
  }, []);

  return (
    <div className="group-colors__popup">
      {Object.keys(colorGroups).map(vidx => {
        let value = colorGroups[vidx];
        let colorsListGroup = colorLists.filter(item => {
          return item.types.hasOwnProperty(vidx) && !item.types.hasOwnProperty('15');
        });

        let titleToShow = null;

        //* tworzymy tytuł dla grupy 2 połączonej z 3
        if (String(vidx) === '13' || String(vidx) === '15') {
          value = `${groupTwoAndFourTitleArray[0]}, ${groupTwoAndFourTitleArray[2]} : ${groupTwoAndFourTitleArray[1]}, ${groupTwoAndFourTitleArray[3]}`;
        }

        if (value.length) {
          titleToShow = value.replace(' - ', ' : ');
        }

        //* łączymy grupę 2 z 3
        if (String(vidx) === '13') {
          const colorsListFourthGroup = colorLists.filter(item => {
            return item.types.hasOwnProperty('15');
          });
          colorsListGroup = [...colorsListGroup, ...colorsListFourthGroup];
        }

        return (
          colorsListGroup.length > 0 && (
            <React.Fragment key={vidx}>
              <h2>{titleToShow}</h2>
              <div className="colors-display">
                {colorsListGroup.map((item, key) => (
                  <div key={'color-list-item_' + key}>
                    <span
                      className="color-list__img"
                      style={{ backgroundImage: `url("${item.icon ?? item.img}")` }}
                      title={item.name ?? item.safo}
                    />
                    <span className="color-list-price">
                      <Currency quantity={item.price.actual} currency="PLN" />
                    </span>
                  </div>
                ))}
              </div>
              {value.includes('Grupa 1') && (
                <p>
                  Dekory dopasowane do kolekcji meblowych Black Red White. Dzięki temu,
                  zaprojektowaną szafę łatwo zestawisz z komodą lub witryną, w wybranym przez siebie
                  wnętrzu.
                </p>
              )}
              {value.includes('Grupa 2') && (
                <p>
                  Dekory nie tylko dopasowane do kolekcji meblowych ale również do bezpośrednio do
                  wykończenia wnętrz. Lacobele pokryte są z jednej strony wysokiej jakości lakierem,
                  który zapewnia błyszczący wygląd oraz uodparnia szybę na zabrudzenia i wilgoć.
                  Płyta laminowana na wysoki biały połysk, jest bardzo łatwa w utrzymaniu czystości
                  oraz odporna na zarysowania, bardzo dobrze prezentuje się z innymi białymi
                  kolekcjami systemowymi.
                </p>
              )}
              {value.includes('Grupa 4') && (
                <p>
                  Dekory dopasowane do kolekcji meblowych z klasyczną ramką ozdobną. Dzięki nim
                  uzyskasz niepowtarzalny klimat swojego wnętrza.
                </p>
              )}
            </React.Fragment>
          )
        );
      })}
    </div>
  );
};

ColorsGroupPopup.propTypes = {
  colorGroups: PropTypes.object,
  colorLists: PropTypes.array,
};

export default ColorsGroupPopup;
